/**

  Authors: Toni Ruottu, Finland 2010-2019

  This file is part of Dark WebSocket Terminal.

  CC0 1.0 Universal, http://creativecommons.org/publicdomain/zero/1.0/

  To the extent possible under law, Dark WebSocket Terminal developers have waived all
  copyright and related or neighboring rights to Dark WebSocket Terminal.

*/

import abstract from './abstract/abstract.js';
import errors from './errors/errors.js';
import m from './m/m.js';
import util from './util/util.js';

export default {
  abstract,
  errors,
  m,
  util,
};
